import React, { useState } from 'react';
import { about } from '../data/portfolioData';
import '../styles/About.css';
const FAN_PHOTOS = [
  { src: '/edc_photo.jpg',        alt: 'EDC' },
  { src: '/f1_photo.jpg',         alt: 'F1' },
  { src: '/mammy_photo.jpg',      alt: 'Mammy' },
  { src: '/trivecta_photo.jpg',   alt: 'Trivecta' },
];

const ANGLES = [-18, -6, 6, 18];

export default function About() {
  const [frontIdx, setFrontIdx] = useState(1);

  return (
    <section className="about" id="about">
      <div className="about__inner">

        {/* ── TEXT ── */}
        <div className="about__text fade-in">
          <h2 className="section-title">
            About <em>Me</em>
          </h2>
          <div className="about__bio">
            {about.bio.map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>
        </div>

        {/* ── FAN PHOTOS ── */}
        <div className="about__fan-wrap fade-in">
          <div className="about__fan">
            {FAN_PHOTOS.map(({ src, alt }, i) => (
              <img
                key={i}
                className="fan-photo"
                style={{
                  transform: `translateX(-50%) rotate(${ANGLES[i]}deg)${i === frontIdx ? ' translateY(-20px)' : ''}`,
                  zIndex: i === frontIdx ? 10 : Math.max(1, 4 - Math.abs(i - frontIdx)),
                }}
                src={src}
                alt={alt}
                loading="lazy"
                onClick={() => setFrontIdx(i)}
              />
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
